import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Field, Form, withFormik, } from 'formik';
import { IconTooltip } from '@anex/common';
import { Error } from '../../../../components';
var initPlan = {
    personal: 'EA-STANDARD-PLUS-NBN-0M',
    business: 'EA-STANDARD-PLUS-NBN-BUNDLE',
};
export var ConnectionDetailsForm = observer(function (props) {
    var config = props.config, appStore = props.appStore, checkAddressStore = props.checkAddressStore, connectionDetailsStore = props.connectionDetailsStore, hardwareStore = props.hardwareStore, summaryStore = props.summaryStore, planStore = props.planStore, setFieldValue = props.setFieldValue, errors = props.errors, values = props.values, touched = props.touched;
    var serviceClassA = [3, 13, 24, 34];
    var previousStep = appStore.previousStep;
    var wholesaleCustomerCode = config.wholesaleCustomerCode;
    var nbnEslaService = values.nbnEslaService;
    var _a = props.planStore.planDetails.formValues, contractCode = _a.contractCode, voipCode = _a.voipCode;
    var contract = planStore.getContract(contractCode);
    React.useEffect(function () {
        var isLineInUse = checkAddressStore.isLineInUse, serviceClass = checkAddressStore.serviceClass;
        if (serviceClassA.includes(serviceClass) && !isLineInUse) {
            setFieldValue('nbnOrderType', 'NewServiceOrder');
        }
    }, []);
    React.useEffect(function () {
        summaryStore.getSummary(contractCode, summaryStore.hardwareCode, checkAddressStore.nbnLocId, voipCode, null, nbnEslaService);
    }, [nbnEslaService]);
    function handleBooleanRadioOption(e, val) {
        setFieldValue(e.target.name, val);
    }
    function handleNbnEslaRadioOption(e, val) {
        setFieldValue(e.target.name, val);
        summaryStore.setNbnEslaServiceValue(val);
    }
    function handleOrderTypeChange(value) {
        setFieldValue('nbnOrderType', value);
        if (value !== 'NewServiceOrder') {
            handleBoxAtPremisesChange('');
        }
    }
    function handleBoxAtPremisesChange(value) {
        setFieldValue('nbnBoxAtPremises', value);
    }
    function wholesaleCustomerName(code) {
        switch (code) {
            case 'EA':
                return 'Energy Australia';
            case 'BDF':
                return 'Acurus';
            case 'OT':
                return 'Accord with Officeworks';
            case 'TOM':
                return 'Tomi';
            case 'ALDI':
                return 'ALDI';
            case 'ISPX':
                return 'Coles';
            case 'PB':
                return 'Pronto Broadband';
            case 'CTL':
                return 'Commtel';
            default:
                return 'Acurus';
        }
    }
    var isLineInUse = checkAddressStore.isLineInUse;
    var providerCode = props.checkAddressStore.providerCode;
    var isBtnNextDisabled = false;
    if (summaryStore.loading) {
        isBtnNextDisabled = true;
    }
    if (serviceClassA.includes(checkAddressStore.serviceClass)) {
        if (isLineInUse) {
            if (values.nbnOrderType === '') {
                isBtnNextDisabled = true;
            }
            if (values.nbnOrderType === 'NewServiceOrder' &&
                [24, 34].includes(checkAddressStore.serviceClass) &&
                values.nbnBoxAtPremises === '') {
                isBtnNextDisabled = true;
            }
        }
        if (!isLineInUse) {
            if ([24, 34].includes(checkAddressStore.serviceClass) &&
                values.nbnBoxAtPremises === '') {
                isBtnNextDisabled = true;
            }
        }
    }
    if (values.priorityAssistance) {
        isBtnNextDisabled = true;
    }
    var NbnBoxAtPremises = function () { return (React.createElement("div", { id: "nbnBoxAtPremise", className: "service-query-result" },
        React.createElement("div", null,
            React.createElement("strong", null, "Do you have an nbn\u2122 box at your premises?"),
            React.createElement("br", null),
            React.createElement("label", { className: "checkbox" },
                React.createElement(Field, { name: "nbnBoxAtPremises", type: "radio", value: "Yes", checked: values.nbnBoxAtPremises == 'Yes', onClick: function () {
                        handleBoxAtPremisesChange('Yes');
                    }, className: "form-control " + (errors.nbnBoxAtPremises &&
                        touched.nbnOrderType &&
                        'error') }),
                React.createElement("small", { className: "label" }, "Yes")),
            React.createElement("label", { className: "checkbox" },
                React.createElement(Field, { name: "nbnBoxAtPremises", type: "radio", value: "No", checked: values.nbnBoxAtPremises == 'No', onClick: function () {
                        handleBoxAtPremisesChange('No');
                    }, className: "form-control " + (errors.nbnBoxAtPremises &&
                        touched.nbnOrderType &&
                        'error') }),
                React.createElement("small", { className: "label" }, "No")),
            React.createElement("label", { className: "checkbox" },
                React.createElement(Field, { name: "nbnBoxAtPremises", type: "radio", value: "NotSure", checked: values.nbnBoxAtPremises == 'NotSure', onClick: function () {
                        handleBoxAtPremisesChange('NotSure');
                    }, className: "form-control " + (errors.nbnBoxAtPremises &&
                        touched.nbnOrderType &&
                        'error') }),
                React.createElement("small", { className: "label" }, "Not Sure")),
            React.createElement("div", { className: "pl-md-5" },
                React.createElement("small", null, "If you answered No or Not sure, we would order one for you and you will receive an nbn\u2122 Box from nbn\u2122 which you will need to install at your premises")),
            React.createElement(Error, { name: "nbnBoxAtPremises" }),
            React.createElement("hr", null)))); };
    return (React.createElement(Form, null,
        isLineInUse && (React.createElement(React.Fragment, null,
            checkAddressStore.serviceClass !== null &&
                serviceClassA.includes(checkAddressStore.serviceClass) && (React.createElement("div", { id: "nbnOrderType", className: "service-query-result" },
                React.createElement("div", null,
                    React.createElement("strong", null,
                        "Existing ",
                        providerCode == 'Uniti' ? 'uniti' : 'nbn',
                        " service has been detected at your premises:"),
                    React.createElement("br", null),
                    React.createElement("label", { className: "checkbox" },
                        React.createElement(Field, { name: "nbnOrderType", type: "radio", value: "NewServiceOrder", checked: values.nbnOrderType == 'NewServiceOrder', className: "form-control " + (errors.nbnOrderType &&
                                touched.nbnOrderType &&
                                'error'), onClick: function () {
                                handleOrderTypeChange('NewServiceOrder');
                            } }),
                        React.createElement("small", { className: "label" }, "I'm a new tenant/occupier at this property")),
                    React.createElement("label", { className: "checkbox" },
                        React.createElement(Field, { name: "nbnOrderType", type: "radio", value: "ServiceTransfer", checked: values.nbnOrderType == 'ServiceTransfer', className: "form-control " + (errors.nbnOrderType &&
                                touched.nbnOrderType &&
                                'error'), onClick: function () {
                                handleOrderTypeChange('ServiceTransfer');
                            } }),
                        React.createElement("small", { className: "label" },
                            "I would like to transfer my existing",
                            ' ',
                            providerCode == 'Uniti' ? 'uniti' : 'nbn',
                            " service to",
                            ' ',
                            wholesaleCustomerName(wholesaleCustomerCode))),
                    React.createElement("div", { className: "pl-md-5" },
                        React.createElement("small", null,
                            "(Once your activation is complete, we recommend contacting your existing broadband provider to ensure your nbn service has been cancelled.)",
                            ' ')),
                    React.createElement(Error, { name: "nbnOrderType" }),
                    React.createElement("hr", null)))),
            values.nbnOrderType === 'NewServiceOrder' &&
                [24, 34].includes(checkAddressStore.serviceClass) && (React.createElement(NbnBoxAtPremises, null)))),
        !isLineInUse && [24, 34].includes(checkAddressStore.serviceClass) && (React.createElement(NbnBoxAtPremises, null)),
        React.createElement("div", { id: "startOrderConnection", className: "service-query-result" },
            React.createElement("div", { className: "w-100" },
                React.createElement("strong", null, "When should we order your connection?"),
                React.createElement("br", null),
                React.createElement("label", { className: "checkbox" },
                    React.createElement(Field, { name: "startOrdering", type: "radio", value: "No", checked: values.startOrdering === false, onChange: function (e) {
                            handleBooleanRadioOption(e, false);
                        } }),
                    React.createElement("small", { className: "label" }, "After a requested date")),
                !values.startOrdering && (React.createElement("div", { className: "pl-md-5" },
                    React.createElement("strong", null, "Select Commencement Date"),
                    React.createElement("br", null),
                    React.createElement("label", { htmlFor: "provisioningCommencementDate", className: "w-50" },
                        React.createElement(Field, { name: "provisioningCommencementDate", type: "date", min: new Date().toLocaleDateString('en-CA'), className: "form-control input-md shadow-alt " + (errors.provisioningCommencementDate &&
                                touched.provisioningCommencementDate &&
                                'error') })),
                    React.createElement(Error, { name: "provisioningCommencementDate" }))),
                React.createElement("label", { className: "checkbox" },
                    React.createElement(Field, { name: "startOrdering", type: "radio", value: "Yes", checked: values.startOrdering === true, onChange: function (e) {
                            handleBooleanRadioOption(e, true);
                            setFieldValue('provisioningCommencementDate', '');
                        } }),
                    React.createElement("small", { className: "label" }, "As soon as possible"))),
            React.createElement(Error, { name: "startOrderConnection" }),
            React.createElement("hr", null)),
        React.createElement("div", { id: "medicalSecurityAlarm", className: "service-query-result" },
            React.createElement("div", null,
                React.createElement("strong", null, "Do you have a medical or security alarm on the property?"),
                React.createElement("br", null),
                React.createElement("label", { className: "checkbox" },
                    React.createElement(Field, { name: "medicalSecurityAlarm", type: "radio", value: "Yes", checked: values.medicalSecurityAlarm === true, onChange: function (e) {
                            handleBooleanRadioOption(e, true);
                        } }),
                    React.createElement("small", { className: "label" }, "Yes")),
                values.medicalSecurityAlarm && (React.createElement("div", { className: "mt-4" },
                    React.createElement("div", { className: "alert alert-info", role: "alert" },
                        React.createElement("h5", { className: "alert-heading" },
                            React.createElement("strong", null, "What you need to know")),
                        React.createElement("p", null, "If you want to keep using your medical or security alarm service, you need to contact the provider to check whether it's compatible with an nbn\u2122 service."),
                        React.createElement("p", null,
                            "We recommend that you register your medical alarm service on the nbn\u2122",
                            ' ',
                            React.createElement("a", { href: "https://www.nbnco.com.au/learn/device-compatibility/medical-alarms", target: "_blank", title: "Medical Alarm Register" }, "Medical Alarm Register"),
                            ".")))),
                React.createElement("label", { className: "checkbox" },
                    React.createElement(Field, { name: "medicalSecurityAlarm", type: "radio", value: "No", checked: values.medicalSecurityAlarm === false, onChange: function (e) {
                            handleBooleanRadioOption(e, false);
                        } }),
                    React.createElement("small", { className: "label" }, "No"))),
            React.createElement("hr", null)),
        React.createElement("div", { id: "priorityAssistance", className: "service-query-result" },
            React.createElement("div", null,
                React.createElement("strong", null, "Are there any people at this property who requires Priority Assistance?"),
                React.createElement("br", null),
                React.createElement("small", null, "Anyone who has been diagnosed with a life threatening medical condition and would be at risk without a phone service."),
                React.createElement("br", null),
                React.createElement("label", { className: "checkbox" },
                    React.createElement(Field, { name: "priorityAssistance", type: "radio", value: "Yes", checked: values.priorityAssistance === true, onChange: function (e) {
                            handleBooleanRadioOption(e, true);
                        } }),
                    React.createElement("small", { className: "label" }, "Yes")),
                React.createElement("label", { className: "checkbox" },
                    React.createElement(Field, { name: "priorityAssistance", type: "radio", value: "No", checked: values.priorityAssistance === false, onChange: function (e) {
                            handleBooleanRadioOption(e, false);
                        } }),
                    React.createElement("small", { className: "label" }, "No")),
                values.priorityAssistance && (React.createElement("div", { className: "mt-4" },
                    React.createElement("div", { className: "alert alert-warning", role: "alert" },
                        React.createElement("span", { className: "alert-icon icon-absolute" },
                            React.createElement(IconTooltip, { fill: "#eac54d" })),
                        React.createElement("p", { className: "pl-5" }, "Sorry, we don't offer Priority Assistance - this product isn't suitable for your household. We recommend you get in touch with Telstra."))))),
            React.createElement("hr", null)),
        wholesaleCustomerCode == 'PB' &&
            contract &&
            contract.planType === 'Business' && (React.createElement("div", { id: "nbnEsla", className: "service-query-result" },
            React.createElement("div", null,
                React.createElement("strong", null, "Do you want to add nbn eSLA (enhanced-12 Service Level)?"),
                React.createElement("br", null),
                React.createElement("small", null, "eSLA stands for Enhanced Service Level Agreement and refers to NBN's commitment to providing a higher level of support by having faster rectification on faults within a specified timeframe. This is essential for businesses to minimise potential service disruption and one of key features that distinguishes a business-grade NBN service from a residential-grade one."),
                React.createElement("br", null),
                React.createElement("label", { className: "checkbox" },
                    React.createElement(Field, { name: "nbnEslaService", type: "radio", value: "Yes", checked: values.nbnEslaService === true, onChange: function (e) {
                            handleNbnEslaRadioOption(e, true);
                            setFieldValue('nbnEslaService', true);
                        } }),
                    React.createElement("small", { className: "label" }, "Yes")),
                React.createElement("label", { className: "checkbox" },
                    React.createElement(Field, { name: "nbnEslaService", type: "radio", value: "No", checked: values.nbnEslaService === false, onChange: function (e) {
                            handleNbnEslaRadioOption(e, false);
                            setFieldValue('nbnEslaService', false);
                        } }),
                    React.createElement("small", { className: "label" }, "No")),
                React.createElement("hr", null)))),
        React.createElement("section", { className: "footer-buttons" },
            React.createElement("button", { type: "button", className: "btn btn-shade btn-back", onClick: previousStep }, "Back"),
            React.createElement("button", { type: "submit", className: "btn btn-next", disabled: isBtnNextDisabled }, "Next"))));
});
export var ConnectionDetails = inject('config', 'checkAddressStore', 'appStore', 'summaryStore', 'saleStore', 'connectionDetailsStore', 'hardwareStore', 'planStore')(withFormik({
    handleSubmit: function (values, bag) {
        bag.props.connectionDetailsStore.setConnectionDetailsFromForm(values);
        bag.props.appStore.nextStep();
    },
    mapPropsToValues: function (_a) {
        var connectionDetailsStore = _a.connectionDetailsStore;
        var initialValues = {
            nbnOrderType: '',
            nbnBoxAtPremises: '',
            startOrdering: true,
            medicalSecurityAlarm: false,
            priorityAssistance: false,
            nbnEslaService: false,
            provisioningCommencementDate: '',
        };
        return connectionDetailsStore.connectionDetails.formValues
            ? connectionDetailsStore.connectionDetails.formValues
            : initialValues;
    },
    validate: function (values, props) {
        var errors = {};
        var hasSpaces = /^\s.*|.+\s$/;
        var isLineInUse = props.checkAddressStore.isLineInUse;
        var isServiceClassA = props.checkAddressStore.serviceClass > 0 &&
            [3, 6, 13, 24, 34].includes(props.checkAddressStore.serviceClass);
        var isNbnBoxAtPremises = props.checkAddressStore.serviceClass > 0 &&
            [24, 34].includes(props.checkAddressStore.serviceClass);
        function checkForSpaces(name) {
            if (hasSpaces.test(values[name])) {
                errors[name] = "Start/end of value must not contain spaces";
            }
        }
        if (isLineInUse && isServiceClassA) {
            if (!values.nbnOrderType) {
                errors.nbnOrderType = 'Please select any nbn service';
            }
            if (values.nbnOrderType === 'NewServiceOrder' &&
                isNbnBoxAtPremises &&
                !values.nbnBoxAtPremises) {
                errors.nbnBoxAtPremises =
                    'Please select if you have nbn box at your premises';
            }
        }
        if (!isLineInUse && isNbnBoxAtPremises && !values.nbnBoxAtPremises) {
            errors.nbnBoxAtPremises =
                'Please select if you have nbn box at your premises';
        }
        if (!values.startOrdering) {
            if (!values.provisioningCommencementDate) {
                errors.provisioningCommencementDate = 'Please select date';
            }
            if (values.provisioningCommencementDate) {
                var today = new Date();
                if (values.provisioningCommencementDate <
                    today.toLocaleDateString('en-CA')) {
                    errors.provisioningCommencementDate =
                        'Date should not be later than date today. Please select again';
                }
            }
        }
        return errors;
    },
})(ConnectionDetailsForm));
//# sourceMappingURL=ConnectionDetails.js.map